import { deleteCookieData, getCookieData, setCookieData, BZNAV_RETURN_URL } from '@repo/common-utils';

export const getSavedReturnUrl = () => {
  const returnUrl = getCookieData(BZNAV_RETURN_URL);
  return returnUrl ? decodeURIComponent(returnUrl) : undefined;
};

export const saveReturnUrl = (returnUrl: string) => {
  setCookieData(BZNAV_RETURN_URL, returnUrl);
};

export const removeReturnUrl = () => {
  deleteCookieData(BZNAV_RETURN_URL);
};
